import { render, staticRenderFns } from "./menu-item-icon.vue?vue&type=template&id=49dfac42&scoped=true&"
import script from "./menu-item-icon.vue?vue&type=script&lang=js&"
export * from "./menu-item-icon.vue?vue&type=script&lang=js&"
import style0 from "./menu-item-icon.vue?vue&type=style&index=0&id=49dfac42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dfac42",
  null
  
)

export default component.exports